export default "__VITE_ASSET__CZNN6F1S__"